import { loadServerAddress } from 'utils/ls/address';
import { loadToken } from '../utils/ls/token';

export const DefaultAddress = 'external.bytedance.com';

export enum MethodName {
  CreateRoom = 'CreateRoom',
  StartRoom = 'StartRoom',
  DeleteRoom = 'DeleteRoom',
}

const urls = {
  WsFrontierUrl: `wss://frontier.snssdk.com/ws/v2`,
  CreateRoom: `room/create`, // 创建会议
  StartRoom: `room/start`, // 删除会议
  DeleteRoom: `room/delete`, // 删除会议
};

export const retrieveWebSpeakerUrl = (): string => {
  const address = loadServerAddress() || DefaultAddress;
  return `wss://${address}/si/api/v1/recognize/ws`;
};

export const retrieveHttpsUrl = (methodName: string): string => {
  const address = loadServerAddress() || DefaultAddress;
  return `https://${address}/si/api/v1/${
    urls[methodName]
  }?token=${loadToken()}`;
};

export default urls;
